export default __webpack_public_path__ + "static/media/login-image.1be57a49.png";